﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VXControlViewTabController = void 0;
class VXControlViewTabController {
    constructor(view) {
        this._view = view;
        const ctrl = this._view.ctrls;
        this._tabs = [ctrl.tabStake, ctrl.tabUnstake];
        this._tabsBtns = [ctrl.btnTabStake, ctrl.btnTabUnstake];
        this._tabsResetFunc = [() => { this.stakeReset(); }, () => { this.unstakeReset(); }];
        ctrl.btnTabStake.onclick = () => this.activeTab(ctrl.tabStake);
        ctrl.btnTabUnstake.onclick = () => this.activeTab(ctrl.tabUnstake);
    }
    showAllTabs() {
        this._tabs.forEach(t => t.show());
        this._tabsBtns.forEach(t => t.show());
    }
    closeTab() {
        this._tabs.forEach((t) => t.hide());
        this._tabs.forEach((b) => b.removeClass('selected'));
        this._tabsBtns.forEach((b) => b.removeClass('selected'));
    }
    activeTab(tab) {
        this.closeTab();
        const ctrl = this._view.ctrls;
        const index = this._tabs.indexOf(tab);
        this._tabs[index].addClass('selected');
        this._tabsBtns[index].addClass('selected');
        this._tabsResetFunc[index].call(this);
        tab.show();
    }
    getActiveTab() { return this._tabs.find(b => b.hasClass('selected')); }
    stakeReset() {
        const ctrl = this._view.ctrls;
        ctrl.lTxStakeVX.text = "0";
        ctrl.lTxStakeValidatorsGas.text = "0";
        ctrl.blockTxStakeValidatorsGas.hide();
        ctrl.iStakeValuePLS.value = "";
        ctrl.rStakeValuePLS.value = "0";
        ctrl.btnStakeSubmit.disable();
    }
    unstakeReset() {
        const ctrl = this._view.ctrls;
        ctrl.lTxUnstakeValue.text = "0";
        ctrl.iUnstakeValueUPLS.value = "";
        ctrl.rUnstakeValueUPLS.value = "0";
        ctrl.btnUnstakeSubmit.disable();
    }
    awaitInLockUIAsync(promise) {
        return __awaiter(this, void 0, void 0, function* () {
            this._view.disable();
            try {
                const result = yield promise;
                this._view.enable();
                return result;
            }
            catch (error) {
                this._view.enable();
                throw error;
            }
        });
    }
}
exports.VXControlViewTabController = VXControlViewTabController;
//# sourceMappingURL=VXControlViewTabController.js.map